import { State } from 'src/types';

export const selectCurrentUser = (state: State) =>
  state.globalUsers.currentUser;
